import { render } from "./PartnerContactForm.vue?vue&type=template&id=e6123818"
import script from "./PartnerContactForm.vue?vue&type=script&lang=js"
export * from "./PartnerContactForm.vue?vue&type=script&lang=js"

import "./PartnerContactForm.vue?vue&type=style&index=0&id=e6123818&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__